import { has, get } from 'lodash';

/**
 * sort the objects by the name field // TODO - make more generic - pass in field path and use lodash get
 * @param {Array} source the source array..
 * @returns {Array} of objects sorted by name
 */
export const sortByName = (source) => {
  try {
    if (Array.isArray(source)) {
      return source.sort((a, b) => {
        var nameA = a?.name.toUpperCase(); // ignore upper and lowercase
        var nameB = b?.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    }
  } catch (error) {
    console.error('Something went wrong trying to sort the array by name '.concat(error));
    return source;
  }
  return source;
};

export const sortByDate = (source, sortField) => {
  try {
    if (Array.isArray(source) && sortField) {
      return source.sort((a, b) => {
        const dateA = has(a, sortField) ? new Date(get(a, sortField)) : null;
        const dateB = has(b, sortField) ? new Date(get(b, sortField)) : null;
        if (dateA < dateB) return -1;
        if (dateA > dateB) return 1;
        return 0;
      });
    }
  } catch (error) {
    console.error('Something went wrong trying to sort the array by date '.concat(error));
    return source;
  }
  return source;
};

export const sortByField = (source, sortField) => {
  try {
    if (Array.isArray(source) && sortField) {
      return source.sort((a, b) => {
        const valueA = has(a, sortField) ? get(a, sortField) : null;
        const valueB = has(b, sortField) ? get(b, sortField) : null;
        if (valueA < valueB) return -1;
        if (valueA > valueB) return 1;
        return 0;
      });
    }
  } catch (error) {
    console.error('Something went wrong trying to sort the array by field '.concat(error));
    return source;
  }
  return source;
};


// WEBPACK FOOTER //
// ./services/sorting.js